import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Headphones, BookOpen, Smartphone } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-20 pb-8 px-4 bg-[#0A0A0A] text-center" data-id="element-115">
      <div className="max-w-4xl mx-auto" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-117">
          <p className="text-base md:text-lg font-bold text-gray-400 mb-4" data-id="element-118">
            🎧 Para personas que quieren aprovechar mejor su tiempo y alimentar
            su mente
          </p>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white leading-snug mb-5" data-id="element-119">
            📚 MegaPack Biblioteca de{' '}
            <span className="bg-[#8FF650] text-black px-2 py-1 inline-block md:mt-0 rounded-sm mt-[20px]" data-id="element-120">
              Crecimiento Personal
            </span>
          </h1>

          <p className="text-lg md:text-xl font-bold text-gray-300 mb-6 max-w-3xl mx-auto" data-id="element-121">
            Todo el conocimiento que necesitás para mejorar tu mentalidad,
            hábitos y forma de pensar.
          </p>

          {/* CSS Product Mockup */}
          <div className="block group mb-6 relative max-w-2xl mx-auto" data-id="element-122">
            <div className="relative aspect-[16/10] w-full flex items-center justify-center" data-id="element-123">
              {/* Background Glow */}
              <div className="absolute inset-0 bg-[#8FF650] opacity-10 blur-3xl rounded-full group-hover:opacity-20 transition-opacity duration-500" data-id="element-124"></div>

              {/* Main Tablet/Device */}
              <div className="relative z-10 w-3/4 h-full bg-[#111827] rounded-3xl border-[6px] border-gray-800 shadow-2xl overflow-hidden flex flex-col transform group-hover:scale-105 transition-transform duration-500" data-id="element-125">
                <div className="bg-gradient-to-br from-gray-900 to-black flex-1 p-5 flex flex-col items-center justify-center text-white relative" data-id="element-126">
                  <div className="absolute top-0 inset-x-0 h-1/2 bg-gradient-to-b from-[#8FF650]/10 to-transparent" data-id="element-127"></div>
                  <BookOpen className="w-14 h-14 text-[#8FF650] mb-3" data-id="element-128" />
                  <h3 className="text-xl font-black text-center uppercase mb-1" data-id="element-129">
                    MegaPack
                  </h3>
                  <p className="text-xs text-gray-400 text-center font-bold" data-id="element-130">
                    3.500+ Recursos
                  </p>
                </div>
              </div>

              {/* Floating Elements */}
              <div className="absolute -right-2 md:-right-8 top-1/4 z-20 w-1/3 aspect-[3/4] bg-gray-900 rounded-lg shadow-2xl border border-gray-700 transform rotate-12 group-hover:rotate-6 transition-transform duration-500 flex flex-col items-center justify-center p-3" data-id="element-131">
                <Headphones className="w-8 h-8 text-[#8FF650] mb-2" data-id="element-132" />
                <p className="text-[10px] md:text-xs font-black text-center text-white" data-id="element-133">
                  2.000
                  <br data-id="element-134" />
                  Audiolibros
                </p>
              </div>

              <div className="absolute -left-2 md:-left-8 bottom-1/4 z-20 w-1/3 aspect-[3/4] bg-gray-900 rounded-lg shadow-2xl border border-gray-700 transform -rotate-12 group-hover:-rotate-6 transition-transform duration-500 flex flex-col items-center justify-center p-3" data-id="element-135">
                <Smartphone className="w-8 h-8 text-[#8FF650] mb-2" data-id="element-136" />
                <p className="text-[10px] md:text-xs font-black text-center text-white" data-id="element-137">
                  1.500
                  <br data-id="element-138" />
                  Ebooks
                </p>
              </div>
            </div>
          </div>

          <p className="text-base md:text-lg font-medium text-gray-400 mb-6 max-w-2xl mx-auto" data-id="element-139">
            Miles de ideas poderosas listas para escuchar o leer en cualquier
            momento del día.
          </p>

          <div className="flex flex-col items-center justify-center gap-3" data-id="element-140">
            <CTAButton text="👉 SÍ, QUIERO ACCEDER AHORA" data-id="element-141" />

            <div className="flex items-center gap-2 text-[#8FF650] font-bold mt-2" data-id="element-142">
              <ShieldCheck className="w-5 h-5" data-id="element-143" />
              <span className="text-sm md:text-base" data-id="element-144">
                ✅ Garantía de satisfacción de 7 días
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}